import {
    SET_TRATAMIENTO,
    SET_NOMBRE,
    SET_APELLIDO_MATERNO,
    SET_APELIIDO_PATERNO,
    SET_ESTADO,
    SET_CIUDAD,
    SET_ID_CONCESIONARIO,
    SET_CONCESIONARIO,
    SET_TELEFONO,
    SET_MOVIL,
    SET_CORREO,
    SET_COMENTARIOS,
    SET_AVISO_PRIVACIDAD,
    SET_TERMINOS_Y_CONDICIONES,
    SET_TRANSFERENCIA_DE_DATOS,
    SET_CONTACO_MARKETING,
    SET_VEIHICULO,
    SET_TIPO_CITA,
    SET_NUMERO_DE_PARTE_ACCESORIOS,
    RESET_STATE,
} from "../types";

const initialState = {
    fuenteSitioWeb: "Accesorios / Collection",
    marca: "Audi",
    tipoRegistro: "",
    fuenteSecundaria: "",
    tercerNivel: "",
    llaveOrigen: "AUSW",
    tratamiento: "Sr",
    nombre: "",
    apellidoMaterno: "",
    apellidoPaterno: "",
    telefono: "",
    celular: "",
    email: "",
    ciudad: "",
    provincia: "",
    concesionariaPreferida: "",
    vehiculoActual: "",
    descripcion: "",
    permisoTransferenciaDatos: false,
    permisoContactoMarketing: false,
    urlWeb: "http://www.audi.com.mx/",
    tipoCita: "Formulario Accesorios / Collection",
    fechaNacimiento: "",
    numeroConcesionaria: "",
    horarioPreferente: "",
    fechaPreferente: "",
    vehiculoInteres: "",
    urlPrivacidad: "http://www.audi.com.mx/mx/web/es.html",
    // sexo: "",
    status: "Nuevo",
    fbCampaignID: "",
    //datos extra para el formulario
    avisoPrivacidad: false,
    terminosCondiciones: false,
    numeroDeParte: "",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_TRATAMIENTO:
            return {
                ...state,
                tratamiento: action.payload,
            };
        case SET_NOMBRE:
            return {
                ...state,
                nombre: action.payload,
            };
        case SET_APELLIDO_MATERNO:
            return {
                ...state,
                apellidoMaterno: action.payload,
            };
        case SET_APELIIDO_PATERNO:
            return {
                ...state,
                apellidoPaterno: action.payload,
            };
        case SET_ESTADO:
            return {
                ...state,
                provincia: action.payload,
            };
        case SET_CIUDAD:
            return {
                ...state,
                ciudad: action.payload,
            };
        case SET_ID_CONCESIONARIO:
            return {
                ...state,
                numeroConcesionaria: action.payload,
            };
        case SET_CONCESIONARIO:
            return {
                ...state,
                concesionariaPreferida: action.payload,
            };
        case SET_TELEFONO:
            return {
                ...state,
                telefono: action.payload,
            };
        case SET_MOVIL:
            return {
                ...state,
                celular: action.payload,
            };
        case SET_CORREO:
            return {
                ...state,
                email: action.payload,
            };
        case SET_COMENTARIOS:
            return {
                ...state,
                descripcion: action.payload,
            };
        case SET_AVISO_PRIVACIDAD:
            return {
                ...state,
                avisoPrivacidad: action.payload,
            };
        case SET_TERMINOS_Y_CONDICIONES:
            return {
                ...state,
                terminosCondiciones: action.payload,
            };
        case SET_TRANSFERENCIA_DE_DATOS:
            return {
                ...state,
                permisoTransferenciaDatos: action.payload,
            };
        case SET_CONTACO_MARKETING:
            return {
                ...state,
                permisoContactoMarketing: action.payload,
            };
        case SET_VEIHICULO:
            return {
                ...state,
                vehiculoInteres: action.payload,
            };
        case SET_TIPO_CITA:
            return {
                ...state,
                tipoCita: action.payload,
            };
        case SET_NUMERO_DE_PARTE_ACCESORIOS:
            return {
                ...state,
                numeroDeParte: action.payload,
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
